export default __webpack_public_path__ + "static/media/pin.e9877487.svg";